import { useContext } from 'react';
import { useLocalObservable } from 'mobx-react';

import BookingContext from '../Contexts/BookingContext';
import BookingService from '../Services/BookingService';
import useAuth from '../../ISO/Hooks/useAuth';
import useApi from '../../ISO/Hooks/useApi';

export default function UseBookingService(): BookingService {
  const context = useContext(BookingContext);
  const bookingService = useLocalObservable<BookingService>(() => context);
  const api = useApi();
  const auth = useAuth();

  bookingService.setApi(api);
  bookingService.setAuth(auth.authService);

  return bookingService;
}
